((document, window, history) => {
	const pushState = history.pushState;

	function setCookie(name, value, days) {
		const expires = new Date();
		expires.setDate(expires.getDate() + days);
		const cookieValue = encodeURIComponent(name) + '=' + encodeURIComponent(value) + '; expires=' + expires.toUTCString() + '; path=/';
		document.cookie = cookieValue;
	  }

	  function cookieCompliance() {
		if (document.querySelector('.farlo-ui-biscuit-banner__button')) {
		  document.querySelector('.farlo-ui-biscuit-banner__button').addEventListener('click', (e) => {
			e.preventDefault();

			e.target.closest('.farlo-ui-biscuit-banner').classList.add('farlo-ui-biscuit-banner--hide');

			// Set the cookie with a 30-day expiry time
			setCookie('cookieCompliance', 'true', 90);
		  });
		}

		if (document.querySelector('.farlo-ui-biscuit-banner__button--close')) {
		  document.querySelector('.farlo-ui-biscuit-banner__button--close').addEventListener('click', (e) => {
			e.preventDefault();

			e.target.closest('.farlo-ui-biscuit-banner').classList.add('farlo-ui-biscuit-banner--hide');
		  });
		}
	  }

	// navigation
	function navigation(submenu) {
		if (('ontouchstart' in window) ||
		(navigator.maxTouchPoints > 0) ||
		(navigator.msMaxTouchPoints > 0)) {
			window._farlo.helpers.getSiblings(submenu)[ 0 ].addEventListener('click', (e) => {
				if (!e.target.classList.contains('site-navigation__menu-item--active')) {
					e.preventDefault();

					e.currentTarget.classList.add('site-navigation__menu-item--active');
					submenu.classList.add('site-navigation__sub-menu--active');

					for (let i = 0; i < window._farlo.helpers.getSiblings(e.currentTarget.parentNode).length; i += 1) {
						if (window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ] && window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ].classList.contains('site-navigation__menu-item--active')) {
							window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ].classList.remove('site-navigation__menu-item--active');
						}

						if (window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ] && window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ].classList.contains('site-navigation__sub-menu--active')) {
							window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ].classList.remove('site-navigation__sub-menu--active');
						}
					}
				} else {
					return true;
				}
			});
		} else {
			submenu.parentNode.addEventListener('mouseover', () => {
				if (submenu.parentNode.querySelector('.site-navigation__sub-menu--active')) {
					submenu.parentNode.querySelectorAll('.site-navigation__sub-menu--active').forEach((_sel) => {
						_sel.classList.remove('site-navigation__sub-menu--active');
						_sel.parentNode.classList.remove('site-navigation__menu-item--active');
					});
				}
				submenu.classList.add('site-navigation__sub-menu--active');
				submenu.parentNode.classList.add('site-navigation__menu-item--active');
			});

			submenu.parentNode.addEventListener('mouseout', () => {
				submenu.classList.remove('site-navigation__sub-menu--active');
				submenu.parentNode.classList.remove('site-navigation__menu-item--active');
			});
		}
	}

	// default navicon
	function navicon() {
		document.querySelector('.site-navigation__navicon').addEventListener('click', (e) => {
			e.preventDefault();
			e.currentTarget.classList.toggle('site-navigation__navicon--active'); document.querySelector('.site-navigation').classList.toggle('site-navigation__nav--active');
			document.body.classList.toggle('site-navigation__nav--open');
		});
	}

	function ariaLabel() {
		const ariaLabels = document.querySelectorAll('.arialabel > a');
		for (let i = 0; i < ariaLabels.length; ++ i) {
			ariaLabels[ i ].setAttribute('aria-label', 'SAW Escape Experience London');
		}
	}

	// first loading animation
	function loadingOverlay() {
		if (document.querySelector('.loading__overlay-active')) {
			window._farlo.storage.set('loadingOverlay', 'true', 'cookie');
		}
	}

	// Routes Overlay
	function guillotineOverlay() {
		document.querySelector('.site-masthead__cta-button').addEventListener('click', (e) => {
			e.preventDefault();
			window.location.href = '/tickets/';
		});
		document.querySelector('.routes__back-button').addEventListener('click', (e) => {
			document.querySelector('.site-masthead__overlay').classList.add('site-masthead__overlay-inactive');
			document.querySelector('.site-masthead__overlay').classList.remove('site-masthead__overlay-active');
			document.body.classList.remove('site-masthead__overlay--open');
		});
	}

	function routesSelect() {
		const buttons = document.querySelectorAll('.route__link');
		for (let i = 0; i < buttons.length; ++ i) {
			buttons[ i ].addEventListener('click', (e) => {
				e.preventDefault();
				window.location.href = '/tickets/';

				// if (e.target.closest('div')) {
				// 	e.target.closest('div').querySelector('.route__overlay').classList.add('route__overlay-active');
				// 	e.target.closest('div').querySelector('.route__overlay').classList.remove('route__overlay-inactive');
				// }
				// document.querySelector('.site-masthead__overlay').classList.add('route__overlay-active');
				// document.querySelector('.site-masthead__overlay').classList.remove('route__overlay-inactive');
			});
		}
	}

	function routeBack() {
		const backButtons = document.querySelectorAll('.route__back-button');
		for (let i = 0; i < backButtons.length; ++ i) {
			backButtons[ i ].addEventListener('click', (e) => {
				e.target.parentNode.parentNode.classList.add('route__overlay-inactive');
				e.target.parentNode.parentNode.classList.remove('route__overlay-active');
				document.querySelector('.site-masthead__overlay').classList.add('route__overlay-inactive');
				document.querySelector('.site-masthead__overlay').classList.remove('route__overlay-active');
			});
		}
	}

	function galleryCarousel(_sel) {
		const config = {
			autoPlay: true,
			prevNextButtons: false,
			pageDots: false,
			draggable: true,
			wrapAround: true
		};

		if (_sel.classList.contains('reviews-slider')) {
			config.autoPlay = 8000;
			config.pageDots = true;
		}

		const slider = new Flickity(_sel, config);
	}

	function faqs() {
		const accordions = document.querySelectorAll('.rank-math-list-item');

		const openAccordion = (accordion) => {
			const answer = accordion.querySelector('.rank-math-answer');
			accordion.classList.add('rank-math-list-item--active');
			if (answer) {
				answer.style.maxHeight = answer.scrollHeight + 'px';
			}
		};

		const closeAccordion = (accordion) => {
			const answer = accordion.querySelector('.rank-math-answer');
			accordion.classList.remove('rank-math-list-item--active');
			if (answer) {
				answer.style.maxHeight = null;
			}
		};

		accordions.forEach((accordion) => {
			const question = accordion.querySelector('.rank-math-question');
			const answer = accordion.querySelector('.rank-math-answer');

			question.onclick = () => {
				if (answer.style.maxHeight) {
					closeAccordion(accordion);
				} else {
					accordions.forEach((acc) => closeAccordion(acc));
					openAccordion(accordion);
				}
			};
		});
	}

	function importantInfoBanner() {
		if (window.innerWidth >= 1024) {
			document.querySelector('.site-footer').style.paddingBottom = (document.querySelector('.site-important-info').clientHeight) + 'px';
		} else if (document.querySelector('.site-masthead__cta')) {
			document.querySelector('.site-footer').style.paddingBottom = (document.querySelector('.site-important-info').clientHeight + document.querySelector('.site-masthead__cta').clientHeight) + 'px';
		} else if (document.querySelector('.site-book-now-button')) {
			document.querySelector('.site-footer').style.paddingBottom = (document.querySelector('.site-important-info').clientHeight + document.querySelector('.site-book-now-button').clientHeight) + 'px';
		}
	}

	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	document.addEventListener('DOMContentLoaded', () => {
		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.site-important-info')) {
			importantInfoBanner();
		}

		if (document.querySelector('.loading__overlay')) {
			loadingOverlay();
		}
		if (document.querySelector('arialabel')) {
			ariaLabel();
		}

		if (document.querySelector('.farlo-ui-biscuit-banner')) {
			cookieCompliance();
		}
		if (document.querySelector('.site-masthead__cta-button')) {
			guillotineOverlay();
		}

		if (document.querySelector('.route__link')) {
			routesSelect();
			routeBack();
		}

		if (document.querySelector('.rank-math-list')) {
			faqs();
		}

		document.querySelectorAll('.wp-block-gallery').forEach((_sel) => {
			galleryCarousel(_sel);
		});

		document.querySelectorAll('.reviews-slider').forEach((_sel) => {
			galleryCarousel(_sel);
		});

		document.querySelectorAll('.site-navigation__sub-menu').forEach((_sel) => {
			navigation(_sel);
		});

		if (document.querySelector('.wp-block-video')) {
			document.querySelectorAll('video').forEach(function(_sel) {
				_sel.addEventListener('playing', (e) => {
					e.target.parentNode.classList.add('wp-block-video--is-playing');
				});

				_sel.onpause = function() {
					_sel.parentNode.classList.remove('wp-block-video--is-playing');
				};
			});
		}

		if (document.querySelector('.wp-block-embed')) {
			document.querySelectorAll('.wp-block-embed__wrapper').forEach(function(_sel) {
				const embedDiv = document.createElement('div');

				if (!embedDiv.length) {
					embedDiv.className = 'wp-block-embed__player';
					_sel.append(embedDiv);

					embedDiv.addEventListener('click', (e) => {
						e.currentTarget.parentNode.classList.toggle('wp-block-embed__wrapper--is-playing');

						e.currentTarget.parentNode.querySelector('iframe').src = e.currentTarget.parentNode.querySelector('iframe').src + '&autoplay=1&playsinline=1&muted=1';
					});
				}
			});
		}

		if (document.querySelector('.wp-block-embed__player')) {
			function videoHover() {
				const videoHoverEl = document.querySelectorAll('.wp-block-embed__player');
				for (let i = 0; i < videoHoverEl.length; ++ i) {
					videoHoverEl[ i ].addEventListener('mouseover', (e) => {
						e.target.parentNode.classList.add('wp-video-hover');
					});
				}
				for (let i = 0; i < videoHoverEl.length; ++ i) {
					videoHoverEl[ i ].addEventListener('mouseout', (e) => {
						e.target.parentNode.classList.remove('wp-video-hover');
					});
				}
			}

			videoHover();
		}
	});

	window.addEventListener('resize', () => {
		if (document.querySelector('.site-important-info')) {
			importantInfoBanner();
		}
	});

	if (typeof navigator !== 'undefined') {
		navigator.serviceWorker.getRegistrations().then(function(registrations) {
			for (const registration of registrations) {
				registration.unregister();
			}
		});
	}
})(document, window, history);
